import React from "react";
import ReactGA from "react-ga";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  Grid,
  TextField,
  Checkbox,
  Button,
  Paper,
  Typography,
  Collapse,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import firebase from "firebase/app";
import "firebase/functions";
import "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { KeyboardDatePicker } from "@material-ui/pickers";
import AddIcon from "@material-ui/icons/Add";
import { withRouter } from "react-router-dom";
const querystring = require("querystring");
// Constants
// const REMOTE_UNTIL_DEFAULT = new Date(new Date().setDate(new Date().getDate()+30));

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  formControl: {
    margin: theme.spacing(3),
  },
  addMarginTop: {
    marginTop: "10px",
  },
  formBoxContent: {
    padding: theme.spacing(4),
  },  
  '@media (max-width: 767px)': {
    formBoxContent: {
      padding: "10px 0 0"
    }
  }
});

const initialState = {
  submitting: false,
  submitted: false,
  companyName: "",
  perm: false,
  employee: false,
  source: "",
  jobsLink: "",
  remoteSince: new Date(),
  remoteUntil: new Date(),
  alwaysBeenRemote: false,
  remotePolicy: "",
  policyDuration: "",
  errors: {
    noEmployeeAndNoSource: null,
    noCompany: null,
    notAlwaysRemoteAndNoPolicy: null,
    wrongEndDate: null,
  },
};

class NewCompanyForm extends React.Component {
  constructor(props) {
    super(props);

    this.r = querystring.parse(props.location.search)["?r"];

    this.state = initialState;
  }

  handleRadioButton = (e) => {
    // Adjust error state so that textfields can reflect issues
    switch (e.currentTarget.id) {
      case "perm":
        this.setState({
          ...this.state,
          perm: !this.state.perm,
        });
        break;
      case "employee":
        this.setState({
          ...this.state,
          employee: !this.state.employee,
          errors: {
            ...this.state.errors,
            noEmployeeAndNoSource:
              !this.state.employee === false && this.state.source === ""
                ? true
                : false,
          },
        });
        break;
      case "alwaysbeenremote":
        this.setState({
          ...this.state,
          alwaysBeenRemote: !this.state.alwaysBeenRemote,
          errors: {
            ...this.state.errors,
            notAlwaysRemoteAndNoPolicy:
              !this.state.alwaysBeenRemote === false &&
              this.state.remotePolicy === ""
                ? true
                : false,
          },
        });
        break;
      case "indefinite":
        this.setState({
          ...this.state,
          policyDuration:
            this.state.policyDuration === "indefinite" ? "" : "indefinite",
        });
        break;
      default:
        break;
    }
  };

  handleTextChange = (e) => {
    // Adjust error state so that textfields can reflect issues
    let existingErrors = this.state.errors;
    if (e.currentTarget.id === "companyName") {
      existingErrors.noCompany = e.currentTarget.value === "" ? true : false;
    } else if (e.currentTarget.id === "source") {
      existingErrors.noEmployeeAndNoSource =
        e.currentTarget.value === "" && !this.state.employee ? true : false;
    }

    // Set new state
    this.setState({
      ...this.state,
      [e.currentTarget.id]: e.currentTarget.value,
      errors: {
        ...existingErrors,
      },
    });
  };

  handleUntilDateChange = (date) => {
    // If they make any change to this then there is no error
    this.setState({
      ...this.state,
      remoteUntil: date,
      errors: {
        ...this.state.errors,
        wrongEndDate: false,
      },
    });
  };

  handleSinceDateChange = (date) => {
    this.setState({
      remoteSince: date,
    });
  };

  handleRemotePolicyChange = (e) => {
    let existingErrors = this.state.errors;
    existingErrors.notAlwaysRemoteAndNoPolicy = false;
    let permState = false;
    if (
      e.currentTarget.id === "fully-distributed" ||
      e.currentTarget.id === "remote-first" ||
      e.currentTarget.id === "remote-friendly"
    ) {
      permState = true;
    } else {
      permState = false;
    }

    this.setState({
      ...this.state,
      remotePolicy: e.currentTarget.id,
      perm: permState,
      existingErrors: {
        ...existingErrors,
      },
    });
  };

  determineUntilDateDisplayProp = () => {
    if (
      this.state.policyDuration === "permanent" ||
      this.state.policyDuration === "indefinite" ||
      this.state.remotePolicy === "remote-first" ||
      this.state.remotePolicy === "fully-distributed" ||
      this.state.remotePolicy === "remote-friendly"
    ) {
      return "none";
    }
    return "block";
  };

  submissionErrorCheck() {
    let newErrors = {},
      errorFound = false;
    // Check end date error specifically
    const remoteUntilDate = new Date(this.state.remoteUntil);
    const today = new Date();
    if (
      !this.state.alwaysBeenRemote &&
      this.state.policyDuration !== "indefinite" &&
      this.state.remotePolicy === "temp-remote" &&
      remoteUntilDate.getMonth() === today.getMonth() &&
      remoteUntilDate.getFullYear() === today.getFullYear() &&
      remoteUntilDate.getDate() === today.getDate()
    ) {
      newErrors.wrongEndDate = true;
      errorFound = true;
    } else {
      newErrors.wrongEndDate = false;
    }
    // Check general errors
    if (
      this.state.errors.noCompany === null ||
      this.state.errors.noCompany ||
      this.state.errors.noEmployeeAndNoSource === null ||
      this.state.errors.noEmployeeAndNoSource ||
      this.state.errors.notAlwaysRemoteAndNoPolicy === null ||
      this.state.errors.notAlwaysRemoteAndNoPolicy
    ) {
      newErrors.noCompany =
        this.state.errors.noCompany === false ? false : true;
      newErrors.noEmployeeAndNoSource =
        this.state.errors.noEmployeeAndNoSource === false ? false : true;
      newErrors.notAlwaysRemoteAndNoPolicy =
        this.state.errors.notAlwaysRemoteAndNoPolicy === false ? false : true;
      errorFound = true;
    }
    // Set state with object
    this.setState({
      ...this.state,
      errors: newErrors,
    });
    return errorFound;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.submissionErrorCheck()) {
      return;
    }

    if (this.r) {
      ReactGA.event({
        category: "Company Data Submission",
        action: "List Job Valid Form Submission",
        label: "CompanyForm.js",
      });
    } else {
      ReactGA.event({
        category: "Company Data Submission",
        action: "Submitted Valid Form",
        label: "CompanyForm.js",
      });
    }

    const db = firebase.firestore();
    const friendlyCompanyName = this.state.companyName.replace(
      /[^a-zA-Z0-9-_]/g,
      ""
    );
    const submissionId = `${friendlyCompanyName}-${uuidv4()}`;
    const companyRef = db.collection("companies").doc(submissionId);
    // To Do: if company is always or permanelty remote, we shouldn't save remoteUntil as a certain date
    const remoteUntil = new Date(this.state.remoteUntil);
    const remoteSinceResult = this.state.alwaysBeenRemote
      ? new Date("1991-08-06")
      : new Date(this.state.remoteSince);


    const submissionsRef = db.collection("policySubmissions").doc(this.state.companyName.toLowerCase()).collection("submissions");
    const increment = firebase.firestore.FieldValue.increment(1);

    this.setState(
      { submitting: true, error: false, errorTxt: "" },
        // add submission to submissions table 
        async () => {

          const docRef = db.collection("policySubmissions").doc(this.state.companyName.toLowerCase());
          const doc = await docRef.get();
    
          if (!doc.exists) {
            await docRef.set({ subCount: 1 })
          } else {
            await docRef.update({ subCount: increment })
          }

          await submissionsRef.add({
            companyName: this.state.companyName,
            id: uuidv4(),
            perm: this.state.perm,
            employee: this.state.employee,
            source: this.state.source || "Internal Email",
            jobsLink: this.state.jobsLink,
            remoteUntil: remoteUntil || "",
            remoteSince: remoteSinceResult || "",
            alwaysBeenRemote: this.state.alwaysBeenRemote,
            submissionDate: new Date(),
            remotePolicy: this.state.remotePolicy,
            policyDuration: this.state.policyDuration,
            isApplyingToList: this.r ? true : false,
            verified: false,
            deleted: false,
          })

          if (this.state.email) {
            await db.collection("airpodSubmissions").add({
              id: uuidv4(),
              email: this.state.email.toLowerCase()
            });
          }
          
          this.setState({ submitting: false, submitted: true });
        }
    )
  }
    
      // async () => {
      //   await companyRef.set({
      //     companyName: this.state.companyName,
      //     perm: this.state.perm,
      //     employee: this.state.employee,
      //     source: this.state.source || "Internal Email",
      //     jobsLink: this.state.jobsLink,
      //     remoteUntil: remoteUntil || "",
      //     remoteSince: remoteSinceResult || "",
      //     alwaysBeenRemote: this.state.alwaysBeenRemote,
      //     verified: false,
      //     submissionDate: new Date(),
      //     remotePolicy: this.state.remotePolicy,
      //     policyDuration: this.state.policyDuration,
      //     isApplyingToList: this.r ? true : false,
      //   });
      //   // Send verification email
      //   const sendVerificationEmail = firebase
      //     .functions()
      //     .httpsCallable("sendVerificationEmail");
      //   sendVerificationEmail({
      //     type: "companySubmission",
      //     companyName: this.state.companyName,
      //     submissionId,
      //     perm: this.state.perm,
      //     employee: this.state.employee,
      //     source: this.state.source,
      //     jobsLink: this.state.jobsLink,
      //     remoteSince: remoteSinceResult.toString(),
      //     remoteUntil: this.state.remoteUntil.toString(),
      //     remotePolicy: this.state.remotePolicy,
      //     isApplyingToList: this.r ? true : false,
      //   });
      //   // Set state
      //   this.setState({ submitting: false, submitted: true });
      // }
    // );
  // };

  clearForm = () => {
    this.setState({ ...initialState });
  };

  render() {
    const { classes } = this.props;
    const { submitting, submitted } = this.state;

    if (submitted) {
      window.scrollTo(0, 0);
      return (
        <div
          className={classes.root}
          id="inputForm"
          style={this.r && { paddingBottom: 500 }}
        >
          <div className={classes.paper} style={{ width: "100%" }}>
            <form onSubmit={(e) => e.preventDefault()} style={{ flexGrow: 1 }}>
              <Grid container spacing={1} className={classes.formBoxContent}>
                {this.r ? (
                  <Grid item xs={12}>
                    <Typography variant="h6" align="center" gutterBottom>
                      Thanks for Submitting! We'll be in touch.
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="h6" align="center" gutterBottom>
                      <b>Successfully submitted!</b>
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ textTransform: "none" }}
                      onClick={this.clearForm}
                    >
                      <AddIcon /> Add Another
                    </Button>
                  </Grid>
                )}
              </Grid>
            </form>
          </div>
        </div>
      );
    }

    return (
      <div className={classes.root} id="inputForm">
        <div className={classes.paper}>
          <form onSubmit={this.handleSubmit}>
            <Grid container spacing={1} className={classes.formBoxContent}>
              <Grid item xs={12}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  {this.r ? <b>Enter your Info</b> : <b>Add a Company</b>}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <h4 style={{ textAlign: "left", marginBlockEnd: "0.7em" }}>
                  Company Info
                </h4>
                <TextField
                  required
                  id="companyName"
                  label="Name of Company"
                  fullWidth
                  error={this.state.errors.noCompany}
                  value={this.state.companyName}
                  onChange={this.handleTextChange}
                />
                <TextField
                  id="jobsLink"
                  label={
                    this.r
                      ? "Job description"
                      : "Link to Careers Page (optional)"
                  }
                  multiline={this.r ? true : false}
                  fullWidth
                  value={this.state.jobsLink}
                  onChange={this.handleTextChange}
                  style={{ marginTop: "15px" }}
                />
              </Grid>
              <Grid align="left" item xs={12} className={classes.addMarginTop}>
                <Grid item xs={12}>
                  <FormGroup component="fieldset" style={{ marginTop: "10px" }}>
                    <h4 style={{ textAlign: "left", marginBlockEnd: "0.7em" }}>
                      Remote Work Policy
                    </h4>
                    <FormControl>
                      <InputLabel>
                        <em>Select</em>
                      </InputLabel>
                      <Select
                        labelId="remoteStatus"
                        id="remoteStatus"
                        value={this.state.remoteStatus}
                        onChange={this.handleRemotePolicyChange}
                        error={this.state.errors.notAlwaysRemoteAndNoPolicy}
                      >
                        <MenuItem disabled value="">
                          <em>Select</em>
                        </MenuItem>
                        <MenuItem
                          id="fully-distributed"
                          value="fully-distributed"
                        >
                          Fully Distributed (no offices)
                        </MenuItem>
                        <MenuItem id="remote-first" value="remote-first">
                          Remote-First
                        </MenuItem>
                        <MenuItem id="remote-friendly" value="remote-friendly">
                          Remote-Friendly
                        </MenuItem>
                        <MenuItem id="temp-remote" value="temp-remote">
                          Temporarily Remote
                        </MenuItem>
                      </Select>
                      <FormHelperText
                        error={this.state.errors.notAlwaysRemoteAndNoPolicy}
                      >
                        {this.state.errors.notAlwaysRemoteAndNoPolicy
                          ? "Please select a remote work policy"
                          : ""}
                      </FormHelperText>
                    </FormControl>
                  </FormGroup>
                </Grid>
                <h4 style={{ marginTop: "50px", textAlign: "left" }}>
                  {" "}
                  Dates of Policy{" "}
                </h4>
                <div style={{ textAlign: "left", fontSize: "16px" }}>
                  Please select one of the checkboxes OR enter the policy dates.
                </div>
                <Grid
                  align="left"
                  item
                  xs={12}
                  className={classes.addMarginTop}
                >
                  <FormGroup component="fieldset">
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          id="alwaysbeenremote"
                          color="primary"
                          checked={this.state.alwaysBeenRemote}
                          onChange={this.handleRadioButton}
                        />
                      }
                      label={
                        <Typography variant="body1" align="left">
                          This has always been the policy
                        </Typography>
                      }
                      labelPlacement="end"
                    />
                    <Collapse in={!this.state.alwaysBeenRemote}>
                      <Collapse
                        in={
                          this.state.remotePolicy !== "" &&
                          this.state.remotePolicy === "temp-remote"
                        }
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              id="indefinite"
                              color="primary"
                              checked={
                                this.state.policyDuration === "indefinite"
                              }
                              onChange={this.handleRadioButton}
                            />
                          }
                          label={
                            <Typography variant="body1" align="left">
                              The policy end date is indefinite
                            </Typography>
                          }
                          labelPlacement="end"
                        />
                      </Collapse>
                      <Grid container justify="flex-start" spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <KeyboardDatePicker
                            fullWidth
                            disableToolbar
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="From"
                            value={this.state.remoteSince}
                            onChange={this.handleSinceDateChange}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <KeyboardDatePicker
                            fullWidth
                            margin="normal"
                            id="date-picker-dialog"
                            label="Until"
                            format="MM/dd/yyyy"
                            value={this.state.remoteUntil}
                            style={{
                              display: this.determineUntilDateDisplayProp(),
                            }}
                            onChange={this.handleUntilDateChange}
                            error={this.state.errors.wrongEndDate}
                            helperText={
                              this.state.errors.wrongEndDate
                                ? "Please select a date after today!"
                                : ""
                            }
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Collapse>
                  </FormGroup>
                </Grid>
                <h4 style={{ marginTop: "50px", textAlign: "left" }}>
                  {" "}
                  Source{" "}
                </h4>
                <div style={{ textAlign: "left", fontSize: "16px" }}>
                  Please select employee OR add a source that we can link to.
                </div>
                <Grid
                  align="left"
                  item
                  xs={12}
                  className={classes.addMarginTop}
                >
                  <FormGroup component="fieldset">
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="employee"
                          size="small"
                          color="primary"
                          checked={this.state.employee}
                          onChange={this.handleRadioButton}
                        />
                      }
                      label={
                        <Typography variant="body1" align="left">
                          Employee
                        </Typography>
                      }
                      labelPlacement="end"
                    />
                  </FormGroup>
                </Grid>
                <Collapse in={!this.state.employee}>
                  <React.Fragment>
                    <div
                      id="source-section"
                      style={{
                        transition: "all 2s",
                      }}
                    >
                      <Grid item xs={12} style={{ marginBottom: "15px" }}>
                        <TextField
                          id="source"
                          label="Source"
                          fullWidth
                          error={this.state.errors.noEmployeeAndNoSource}
                          helperText={
                            this.state.errors.noEmployeeAndNoSource
                              ? "Please enter a source or select the employee checkbox"
                              : ""
                          }
                          placeholder="url"
                          onChange={this.handleTextChange}
                        />
                      </Grid>
                    </div>
                  </React.Fragment>
                </Collapse>
                <h4 style={{ marginTop: "20px", textAlign: "left" }}>
                  {" "}
                  Airpods Giveaway (optional){" "}
                </h4> 
                <div style={{ textAlign: "left", fontSize: "16px" }}>
                  Enter your email for a chance to win a pair of Apple Airpods. 1 in 100 submissions is a winner.
                </div>   
                <React.Fragment>
                    <div
                      id="source-section"
                      style={{
                        transition: "all 2s",
                      }}
                    >
                      <Grid item xs={12} style={{ marginBottom: "15px" }}>
                        <TextField
                          id="email"
                          label="Email"
                          fullWidth
                          placeholder="your@email.com"
                          onChange={this.handleTextChange}
                        />
                      </Grid>
                    </div>
                  </React.Fragment>              
              </Grid>

              <Grid item xs={12} style={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  fullWidth
                >
                  Submit
                </Button>
                {this.state.error ? (
                  <Typography style={{ color: "red" }}>
                    {this.state.errorTxt}
                  </Typography>
                ) : (
                  <Typography> </Typography>
                )}
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(NewCompanyForm));
